var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIntegrations = function SvgIntegrations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "integrations_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#integrations_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.999 17.18a2.9 2.9 0 0 1-2.128-.886q-.885-.885-.885-2.127 0-1.243.885-2.128T5 11.154t2.128.885.885 2.128-.885 2.127q-.886.885-2.128.885m10 0a2.9 2.9 0 0 1-2.128-.886q-.885-.885-.885-2.127 0-1.243.885-2.128.886-.885 2.128-.885 1.243 0 2.128.885.885.886.885 2.128t-.885 2.127-2.128.885m-10-1.25q.728 0 1.245-.518t.518-1.246-.518-1.245a1.7 1.7 0 0 0-1.245-.517q-.728 0-1.245.518t-.518 1.245.518 1.245 1.245.518m10 0q.727 0 1.245-.518t.518-1.246-.518-1.245a1.7 1.7 0 0 0-1.245-.517q-.727 0-1.245.518t-.518 1.245.518 1.245 1.245.518m-5-3.673q-.594 0-1.009-.415a1.37 1.37 0 0 1-.414-1.009q0-.594.414-1.008A1.37 1.37 0 0 1 10 9.41q.595 0 1.009.415.414.414.414 1.008t-.414 1.01a1.37 1.37 0 0 1-1.009.414m0-4.244a2.9 2.9 0 0 1-2.128-.885Q6.986 6.243 6.986 5t.885-2.128T10 1.987a2.9 2.9 0 0 1 2.128.885q.885.886.885 2.128 0 1.243-.885 2.128a2.9 2.9 0 0 1-2.128.885m0-1.25q.727 0 1.245-.518T11.762 5t-.518-1.245a1.7 1.7 0 0 0-1.245-.518q-.727 0-1.245.518T8.236 5t.518 1.245 1.245.518"
  }))));
};
export default SvgIntegrations;